"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var VSplit_styles_1 = require("./VSplit.styles");
var VSplit_classNames_1 = require("./VSplit.classNames");
var ViewFactory_1 = require("./ViewFactory");
var utilities_1 = require("@uifabric/utilities");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var VSplit = /** @class */ (function (_super) {
    __extends(VSplit, _super);
    function VSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._resize = function (e) {
            var minItemHeight = _this.props.vsplit.minItemHeight;
            var bounds = _this._ref.getBoundingClientRect();
            var splitterBounds = _this._splitterRef.getBoundingClientRect();
            var max = bounds.height - splitterBounds.height - minItemHeight;
            var splitterPos = e.clientY - bounds.top;
            if (splitterPos <= minItemHeight) {
                splitterPos = minItemHeight;
            }
            else if (splitterPos >= max) {
                splitterPos = max;
            }
            var offset = splitterPos / bounds.height;
            _this.props.vsplit.setOffset(offset);
        };
        _this._onDocumentMouseUp = function (e) {
            _this._ref.ownerDocument.removeEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.removeEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.vsplit.setSplitActive(false);
        };
        _this._onDocumentMouseMove = function (e) {
            e.preventDefault();
            _this._resize(e);
        };
        _this._onSplitterMouseDown = function (e) {
            e.preventDefault();
            _this._ref.ownerDocument.addEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.addEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.vsplit.setSplitActive(true);
        };
        _this._onRef = function (ref) {
            _this._ref = ref;
        };
        _this._onSplitterRef = function (ref) {
            _this._splitterRef = ref;
        };
        return _this;
    }
    VSplit.prototype.render = function () {
        var _a = this.props, vsplit = _a.vsplit, styles = _a.styles, className = _a.className;
        var classNames = VSplit_classNames_1.getClassNames(VSplit_styles_1.getStyles(null, styles), className);
        var topContent = ViewFactory_1.ViewFactory(vsplit.top);
        var bottomContent = ViewFactory_1.ViewFactory(vsplit.bottom);
        return (React.createElement("div", { className: classNames.root, ref: this._onRef },
            React.createElement("div", { className: classNames.topPane, style: { height: vsplit.topHeight } },
                React.createElement("div", { className: classNames.topContent }, topContent)),
            React.createElement("div", { className: utilities_1.css(classNames.splitter, { active: vsplit.splitActive }), onMouseDown: this._onSplitterMouseDown, style: { top: vsplit.topHeight, height: vsplit.splitterHeight }, ref: this._onSplitterRef },
                React.createElement("div", { className: utilities_1.css(classNames.splitterHandle, { active: vsplit.splitActive }) },
                    React.createElement(Icon_1.Icon, { iconName: "GripperBarHorizontal", className: "vsplit-icon" }))),
            React.createElement("div", { className: classNames.bottomPane, style: { height: vsplit.bottomHeight } },
                React.createElement("div", { className: classNames.bottomContent }, bottomContent))));
    };
    VSplit = __decorate([
        mobx_react_1.observer
    ], VSplit);
    return VSplit;
}(React.Component));
exports.VSplit = VSplit;
